export enum ContactsDataEventObjectsEnum {
  ACCOUNT_DETAILS = 'account_details',
  COLUMN_SHOWN = 'column_shown',
  COLUMN_HIDDEN = 'column_hidden',
  PROPERTY_DRAGGED = 'property_dragged',
  COLUMN_CONFIG_SEARCHED = 'column_config_searched',
  COLUMN_CONFIG_OPENED = 'column_config_opened',
}
